module.exports = __webpack_public_path__ + "img/title3_3.3608d600.png";